/* ============================================================
   GOB Club toggle (T5) — PDP buy box
   Drives the existing gob-membership.js state machine.

   CART SYNC (21 Sep 2026). The frame used to start OFF on every page, whatever
   the cart held, so a shopper who applied the Club in the cart drawer came back
   to a product page that offered it to them again at full price. The cart is
   now the source of truth for the "applied" state:

     · membership in the cart  → frame ON, member prices, "✓ Applied", the
                                 panel's fee row reads "in your basket" and
                                 Due today is the member price alone;
     · not in the cart         → the old behaviour, unchanged: tapping ON is an
                                 intent, and Add to cart puts the membership in.

   It follows the cart on first paint (Liquid writes data-club-in-cart), on
   every cart event the theme and the drawer receipt fire, and on bfcache
   restores (pageshow), which is the back-button case. Tapping the frame while
   the membership is in the cart REMOVES it — the same thing the drawer's
   Remove does — so the two surfaces can never disagree.

   gob-membership.js reads window.GOBClub.inCart for one thing only: the Add to
   cart label, which must not subtract the fee a second time.
   ============================================================ */
(function () {
  'use strict';

  function clean(html) {
    return String(html)
      .replace(/<sup>0+<\/sup>/, '')
      .replace(/[.,]00([^0-9]|$)/, '$1');
  }

  /* The headline reads as a sentence and has to match the Liquid first paint,
     which uses money_without_trailing_zeros and so has no superscript. Flatten
     the <sup> back into the locale's decimal separator. */
  function flat(html) {
    var f = (window.theme && theme.settings && theme.settings.moneyFormat) || '';
    var sep = f.indexOf('comma_separator') > -1 ? ',' : '.';
    return String(html).replace('<sup>', sep).replace('</sup>', '');
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
      var out = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      if (theme.settings.superScriptPrice && out.indexOf('<sup>') === -1) {
        var sep = (out.indexOf(',') !== -1 && theme.settings.moneyFormat &&
                   theme.settings.moneyFormat.indexOf('amount_with_comma') !== -1) ? ',' : '.';
        if (out.indexOf(sep) !== -1) out = out.replace(sep, '<sup>') + '</sup>';
      }
      return out;
    }
    return (cents / 100).toFixed(2);
  }

  function init(widget) {
    if (widget.dataset.gobToggleInit === '1') return;

    var toggle = widget.querySelector('[data-club-toggle]');
    var panel  = widget.querySelector('[data-club-panel]');
    var title  = widget.querySelector('[data-toggle-title]');
    var optStd = widget.querySelector('[data-option="standard"]');
    var optMem = widget.querySelector('[data-option="member"]');
    if (!toggle || !optStd || !optMem) return;

    widget.dataset.gobToggleInit = '1';

    var scope = widget.closest('[data-section-id]') ||
                widget.closest('.product-single') ||
                document;

    /* ── cart state ──────────────────────────────────────────────────────── */
    var MEMBER_PID = (window.GOBMembership && GOBMembership.productId) || 10601114403149;
    var inCart = widget.dataset.clubInCart === 'true';
    var busy   = false;
    window.GOBClub = window.GOBClub || {};
    window.GOBClub.inCart = inCart;

    function cartHasMembership(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].product_id) === String(MEMBER_PID)) return true;
      }
      return false;
    }

    function readCart() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    /* The drawer rebuilds off these two events and its handlers read
       event.detail.cart, so the payload is not optional. Same broadcast the
       drawer receipt uses after its own writes. */
    function announce(cart) {
      ['cart:updated', 'cart:build'].forEach(function (ev) {
        try { document.dispatchEvent(new CustomEvent(ev, { detail: { cart: cart } })); } catch (e) {}
      });
    }

    /* gob-membership.js binds the option handlers at window.load + 200ms. A
       click fired before that does nothing, and the member price never shows.
       initGobForm stamps the form when it is done — wait for that stamp. */
    function whenMembershipReady(fn) {
      var form = scope.querySelector('.product-single__form');
      var tries = 0;
      (function poll() {
        if ((form && form.dataset.gobInit === '1') || tries++ > 70) { fn(); return; }
        setTimeout(poll, 60);
      })();
    }

    function variantPrice() {
      var json = scope.querySelector('script[data-product-json]');
      var sel  = scope.querySelector('[data-product-select]');
      if (json && sel) {
        try {
          var data = JSON.parse(json.textContent);
          var id = parseInt(sel.value, 10);
          for (var i = 0; i < data.variants.length; i++) {
            if (data.variants[i].id === id) return data.variants[i].price;
          }
          if (typeof data.price === 'number') return data.price;
        } catch (e) {}
      }
      var raw = optMem.getAttribute('data-member-price');
      if (raw) return Math.round(parseFloat(raw.replace(',', '.')) * 100 / 0.7);
      return null;
    }

    function refresh() {
      var price = variantPrice();
      if (!price) return;

      var kit  = price - Math.floor(price * 30 / 100);  /* V93: Shopify's rounding */
      var club = (window.GOBMembership && GOBMembership.price) || 0;
      /* Net of the membership fee — the headline is the frame's single claim and
         has to agree with the signal underneath and the Add to cart label. Below
         the break-even point there is no figure worth claiming, so the rate is
         shown instead (see the fallback in the title write below). */
      var save = price - kit - club;

      var elItem  = widget.querySelector('[data-panel-item]');
      var elClub  = widget.querySelector('[data-panel-club]');
      var elTotal = widget.querySelector('[data-panel-total]');
      /* The kit line shows the saving being made: the normal price struck
         through, then the club price. This rewrites the whole cell, so both
         halves have to be built here — the markup in the snippet only survives
         until the first refresh(). Keep the two in step. */
      if (elItem)  elItem.innerHTML  =
        '<s class="gob-club-panel__was">' + money(price) + '</s>' +
        '<span class="gob-club-panel__now">' + money(kit) + '</span>';
      /* Fee already in the basket: do not charge it to this item a second time.
         The fee row says where it is, and Due today is the member price alone. */
      if (inCart) {
        if (elClub)  elClub.innerHTML  = '<span class="gob-club-panel__in">&#10003; in your basket</span>';
        if (elTotal) elTotal.innerHTML = money(kit);
      } else {
        if (elClub)  elClub.innerHTML  = money(club);
        if (elTotal) elTotal.innerHTML = money(kit + club);
      }

      /* R1: the headline is fixed — it states the reward, not the saving, so it
         carries no number and stays true at every price point. The euro figure
         lives in the signal line underneath, already net of the membership fee.
         `save` above is left in place because the panel maths reads the same
         numbers and the comment there explains the net-of-fee rule. */
      if (title) title.innerHTML = 'Get 30% off this order';
    }

    function setState(on, fire) {
      toggle.classList.toggle('is-on', on);
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (panel) panel.hidden = !on;

      // keep the existing widget's state in sync
      optStd.classList.toggle('is-selected', !on);
      optMem.classList.toggle('is-selected', on);

      if (fire) {
        /* A non-bubbling click. gob-membership.js listens on the option itself,
           so it still fires — but nothing above hears it. element.click() bubbles
           to window, where the theme's cart drawer treats any click outside
           itself as "close me": applying the Club IN the drawer synced this
           frame, this frame clicked its option, and the drawer shut in the
           shopper's hand. The shopper's own tap on the frame still bubbles as
           it always did. */
        try {
          (on ? optMem : optStd).dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
        } catch (e) {
          try { (on ? optMem : optStd).click(); } catch (e2) {}
        }
      }

      /* Both states show the same headline now; the CTA underneath is what
         changes, and CSS swaps its two labels off .is-on. */
      if (title) {
        title.innerHTML = toggle.getAttribute('data-label-off') || 'Get 30% off this order';
      }
      refresh();
    }

    /* Bring the frame in line with a cart snapshot. Only touches the DOM when
       the answer changed, so a cart event about something else is a no-op. */
    function sync(cart) {
      var now = cartHasMembership(cart);
      if (now === inCart) { refresh(); return; }
      inCart = now;
      window.GOBClub.inCart = inCart;
      widget.dataset.clubInCart = inCart ? 'true' : 'false';
      /* Into the cart: the frame goes ON whatever it showed before. Out of the
         cart: the frame goes OFF — the drawer's Remove has to be visible here,
         or the page still prints a member price checkout will not give. */
      if (inCart) { whenMembershipReady(function () { setState(true, true); }); }
      else { setState(false, true); }
    }

    function syncFromServer() {
      readCart().then(sync).catch(function () {});
    }

    /* Mirror of the drawer receipt's Remove. The membership line carries a
       selling plan, so its key is not the variant id: it has to come from
       /cart.js. The cart guard caches GET /cart.js for ~800ms, hence the pause
       before re-reading. */
    function removeFromCart() {
      if (busy) return;
      busy = true;
      toggle.classList.add('is-busy');
      readCart()
        .then(function (cart) {
          var line = null;
          (cart.items || []).forEach(function (i) {
            if (String(i.product_id) === String(MEMBER_PID)) line = i;
          });
          if (!line) return cart;
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); });
        })
        .then(function () { return new Promise(function (res) { setTimeout(res, 320); }); })
        .then(readCart)
        .then(function (cart) { announce(cart); sync(cart); })
        .catch(function () { /* leave the frame as it was — the cart did not change */ })
        .then(function () { busy = false; toggle.classList.remove('is-busy'); });
    }

    /* V93 (29 Sep 2026, Markas): "Apply 30% off" puts GOB Club IN THE CART
       straight away, instead of only switching the page to member prices until
       Add to cart. The cart is then the one source of truth for every member
       price on the site (html.gob-club-on, see gob-club-prices.js): nobody can
       browse member prices and then be charged the full price at checkout.
       Tapping again removes it, exactly like the drawer's Remove. */
    var MEMBER_VID  = 53631345131853;
    var MEMBER_PLAN = 692298416461;
    function addToCart() {
      if (busy) return;
      busy = true;
      toggle.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: MEMBER_VID, quantity: 1, selling_plan: MEMBER_PLAN,
                                         properties: { _gob_upsell: 'pdp:club' } }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return new Promise(function (res) { setTimeout(res, 320); }); })
        .then(readCart)
        .then(function (cart) { announce(cart); sync(cart); })
        .catch(function () { syncFromServer(); })
        .then(function () { busy = false; toggle.classList.remove('is-busy'); });
    }

    toggle.addEventListener('click', function () {
      if (busy) return;
      if (inCart) { removeFromCart(); return; }
      addToCart();
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle.click();
      }
    });

    var sel = scope.querySelector('[data-product-select]');
    if (sel) sel.addEventListener('change', function () { setTimeout(refresh, 80); });
    document.addEventListener('variant:change', function () { setTimeout(refresh, 80); });

    /* Cart events: the drawer receipt sends the cart in event.detail; the
       theme's own events may not, so fall back to a read. */
    ['cart:updated', 'cart:build', 'cart:refresh', 'ajaxProduct:added', 'cart:open', 'CartDrawer:open'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var c = e && e.detail && e.detail.cart;
        if (c && c.items) { sync(c); return; }
        /* No payload (ajaxProduct:added carries the product, not the cart).
           Read once soon, and once more after the theme has finished its own
           writes — the cart guard caches GET /cart.js, so the second read is
           free when nothing changed. */
        setTimeout(syncFromServer, 150);
        setTimeout(syncFromServer, 1500);
      });
    });
    /* Back button. The page comes out of bfcache exactly as it was left, with
       whatever the cart looked like then — so ask again. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) syncFromServer();
    });

    // initial paint
    if (inCart) {
      /* Liquid already drew the frame ON; the price swap needs gob-membership.js */
      setState(true, false);
      whenMembershipReady(function () { setState(true, true); });
    } else {
      // no click, so nothing races with gob-membership.js
      setState(false, false);
      setTimeout(refresh, 250);
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-membership-pricing]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();